module.exports = __webpack_public_path__ + "static/media/Strudel-Etherium-Icon.5036cdda.png";